import { Component, Input, OnInit } from '@angular/core';
import { RowClassArgs } from '@progress/kendo-angular-grid';
import { IOrderPosition } from 'src/app/orders/models/order';

@Component({
    selector: 'app-order-positions',
    templateUrl: './order-positions.component.html',
    styleUrls: ['./order-positions.component.scss'],
    standalone: false
})
export class OrderPositionsComponent implements OnInit {

  constructor() { }

  @Input() orderPositions: IOrderPosition[];

  public rowClass = (context: RowClassArgs) => {
    return { 'inactive-product': !context.dataItem.product?.isActive };
  };

  ngOnInit(): void {
  }

}
